<template>
  <ActionPopoverForm
    v-loading="isLoadingCampaigns"
    :show="show"
    :title="$t('ADVERTISEMENT.ADD_TO_NEGATIVE_KEYWORDS')"
    class="keyword-planner-add-negative-keyword"
    :is-loading="isAddingNegativeKeyword"
    @hide="closeAndReset"
    @save="validateAndAddNegativeKeyword"
    @back="resetAndBack"
  >
    <ElForm ref="addNegativeKeywordForm" :rules="rules" :model="formModel">
      <ElFormItem
        prop="campaign"
        :label="$t('ADVERTISEMENT.KEYWORDPLANNER.ADD_TO_CAMPAIGN')"
      >
        <ElSelect v-model="formModel.campaign">
          <ElOption
            v-for="campaign in campaigns"
            :key="campaign.id"
            :label="campaign.name"
            :value="campaign.id"
          />
        </ElSelect>
      </ElFormItem>
    </ElForm>
  </ActionPopoverForm>
</template>

<script>
import { SearchAdsCampaigns, KeywordPlanner } from '@/api/api';
import { AD_KEYWORD_PLANNER_ADD_TO_NEGATIVE_KEYWORD_MODAL_BUTTON } from '@/constants/gtm-events';
import required from '@/utils/validation-rules/required';
import form from '@/mixins/form';
import ActionPopoverForm from '../../../../../common/ActionPopoverForm';
import extractQueryTransformer from '../common/extractQueryTransformer';

const FORM_REF_NAME = 'addNegativeKeywordForm';

export default {
  name: 'KeywordPlannerAddNegativeKeyword',
  components: {
    ActionPopoverForm,
  },
  mixins: [form],
  inject: ['$selectedSuggestedKeywords'],
  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      formModel: {
        campaign: '',
      },
      campaigns: [],
      isLoadingCampaigns: true,
      isAddingNegativeKeyword: false,
    };
  },
  computed: {
    rules() {
      const requiredRule = {
        ...required(this.$t('VALIDATION_REQUIRED_ERR')),
        trigger: ['blur', 'change'],
      };
      return {
        campaign: requiredRule,
      };
    },
  },
  mounted() {
    this.getCampaigns();
  },
  methods: {
    closeAndReset() {
      this.reset().then(() => {
        this.close();
      });
    },
    resetAndError(errors) {
      this.reset().then(() => {
        this.$emit('error', errors);
      });
    },
    reset() {
      return this.resetForm(FORM_REF_NAME);
    },
    resetAndBack() {
      this.reset().then(() => {
        this.$emit('back');
      });
    },
    validateAndAddNegativeKeyword() {
      if (!this.isValid(FORM_REF_NAME)) return false;

      return this.addNegativeKeyword();
    },
    addNegativeKeyword() {
      this.$gtm.trackEvent(
        AD_KEYWORD_PLANNER_ADD_TO_NEGATIVE_KEYWORD_MODAL_BUTTON,
      );

      this.isAddingNegativeKeyword = true;
      return KeywordPlanner.addBulkNegativeKeyword({
        campaignId: this.formModel.campaign,
        queries: extractQueryTransformer(this.$selectedSuggestedKeywords()),
      })
        .then(({ message, errors }) => {
          if (!errors.length) {
            this.$message.success(message);
            this.closeAndReset();
            return;
          }

          this.resetAndError(errors);
        })
        .catch(({ message }) => {
          this.$message.error(message);
        })
        .finally(() => {
          this.isAddingNegativeKeyword = false;
        });
    },
    getCampaigns() {
      this.isLoadingCampaigns = true;
      return SearchAdsCampaigns.getCampaigns()
        .then(campaigns => {
          this.campaigns = campaigns;
        })
        .catch(({ message }) => {
          if (message) {
            this.$message.error(message);
          }
          this.close();
        })
        .finally(() => {
          this.isLoadingCampaigns = false;
        });
    },
    close() {
      this.$emit('hide');
    },
  },
};
</script>

<style lang="scss">
.keyword-planner-add-negative-keyword {
  color: $lb-black;

  .el-form-item__content {
    @include rtl() {
      margin-left: 0 !important;
      margin-right: 150px;
    }
  }
}
</style>
